import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Auth } from './auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SuperAdminGuard implements CanActivate {

  constructor(private auth: Auth, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return Observable.create(observer => {
      this.auth.isAuthenticated().then(isAuthenticated => {
        if (isAuthenticated && this.auth.user.superAdmin) {
          observer.next(true);
          observer.complete();
        } else {
          this.router.navigate(['/']);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/superadmin.guard.ts